// extracted by mini-css-extract-plugin
module.exports = {"filterItem":"searchProviderFilterView_filterItem__2VW69","label":"searchProviderFilterView_label__2mDcF"};